export default {
  Profile: {
    Home: {
      update_success: 'User updated successfully',
    },
    Header: {
      subtitle: 'User settings',
      title: 'Profile',
    },
  },
}
